$(function(){
    var modelPopupAskTheAnalystBtn = $("[data-target='#modelPopupAskTheAnalyst']"),
        modelPopupAskTheAnalystPopup = $('#modelPopupAskTheAnalyst');
	if (modelPopupAskTheAnalystBtn.length) {
        var iframeUrl, modalHeading, modalSubHeading, iframeHeight;
        modelPopupAskTheAnalystBtn.click(function () {
            iframeUrl = $(this).attr("href"),
            modalHeading = $(this).attr("data-modal-heading"),
            modalSubHeading = $(this).attr("data-modal-subheading"),
            iframeHeight = $(this).attr("data-iframe-height");
			$(modelPopupAskTheAnalystPopup).find("iframe").attr("src", iframeUrl);
            $(modelPopupAskTheAnalystPopup).find("iframe").attr("height", iframeHeight);
            
            $(modelPopupAskTheAnalystPopup).find(".custom-popup-header > h4").html(modalHeading);
            $(modelPopupAskTheAnalystPopup).find(".custom-popup-header > p").html(modalSubHeading);
        });

		$(modelPopupAskTheAnalystPopup).on('click', ".close", function (e) {
			$(modelPopupAskTheAnalystPopup).find("iframe").attr("src", "");
            $(modelPopupAskTheAnalystPopup).find(".custom-popup-header > h4").html("");
            $(modelPopupAskTheAnalystPopup).find(".custom-popup-header > p").html("");
            $(modelPopupAskTheAnalystPopup).find("iframe").attr("height", "");
		});
    }
});